import { render } from "./LegoTextInput.vue?vue&type=template&id=5a136e16&scoped=true"
import script from "./LegoTextInput.vue?vue&type=script&lang=js"
export * from "./LegoTextInput.vue?vue&type=script&lang=js"

import "./LegoTextInput.vue?vue&type=style&index=0&id=5a136e16&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5a136e16"

export default script